import isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import { Dashboard } from '@components/common';
import { HeadContent, Pagination, usePagination } from '@fourthwall/components';
import { DonationsData } from './components/DonationsData/DonationsData';
import { DonationsEmptyState } from './components/DonationsEmpyState/DonationsEmptyState';
import { useDonationsQuery } from './queries/useDonationsQuery';
export const PER_PAGE = 25;
export const DonationsList = () => {
    const [currentPage, setCurrentPage] = usePagination();
    const { donationsQuery } = useDonationsQuery([{ page: currentPage - 1, size: PER_PAGE }], {
        keepPreviousData: true,
    });
    const donations = donationsQuery.data?.donations || [];
    const totalPages = donationsQuery.data?.page.totalPages;
    const isFetching = donationsQuery.isInitialLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Donations" }),
        !isEmpty(donations) || isFetching ? (React.createElement(React.Fragment, null,
            React.createElement(Dashboard.Section.Item, null,
                React.createElement(DonationsData, { data: donations || [], isLoading: isFetching })),
            totalPages && totalPages > 0 && (React.createElement(Dashboard.Section.Item, null,
                React.createElement(Pagination, { pageCount: totalPages, currentPage: currentPage, onChange: setCurrentPage }))))) : (React.createElement(Dashboard.Section.Item, null,
            React.createElement(DonationsEmptyState, null)))));
};
